import { adminInvitationsEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiInvitationHandler } from "@/services/shared";
import type { ApiInvitationType, CreateInvitationRequestType, InvitationType } from "@/types";

export const createInvitationHandler = async ({ email }: CreateInvitationRequestType): Promise<InvitationType> => {
    const response = await axiosClient.post<{
        invitation: ApiInvitationType,
        message: string,
    }>(
        adminInvitationsEndpoints.base,
        { email },
    );

    return transformApiInvitationHandler(response.data.invitation);
};
